function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1333.215 991.956h-799.927c-1.913 0.028-4.171 0.044-6.432 0.044-259.584 0-470.387-208.863-473.521-467.705l-0.003-24.294c3.137-259.137 213.939-468.001 473.524-468.001 2.261 0 4.52 0.016 6.773 0.048l799.585-0.004c1.913-0.028 4.171-0.044 6.432-0.044 259.584 0 470.387 208.863 473.521 467.705l0.003 25.094c-3.584 258.79-214.21 467.201-473.514 467.201-2.265 0-4.526-0.016-6.784-0.048zM533.289 327.217c-0.48-0.005-1.048-0.007-1.616-0.007-95.468 0-173.018 76.717-174.367 171.864l-0.002 24.924c0.901 95.622 78.627 172.792 174.377 172.792 0.565 0 1.13-0.003 1.693-0.008l799.84 0.001c0.48 0.005 1.048 0.008 1.616 0.008 95.468 0 173.018-76.717 174.367-171.864l0.002-24.924c-0.901-95.622-78.627-172.792-174.377-172.792-0.565 0-1.13 0.003-1.693 0.008z",
  "p-id": 5151
});

function SvgOculus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1602691172476,
    className: "icon",
    viewBox: "0 0 1877 1024",
    "p-id": 5150,
    width: 366.6015625,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOculus);
export default __webpack_public_path__ + "static/media/oculus.183ed750.svg";
export { ForwardRef as ReactComponent };